import PropTypes from 'prop-types';
import React from 'react'


export default class extends React.Component {
    static propTypes = {
		addUpdateField: PropTypes.func.isRequired,
		editing_fields: PropTypes.bool.isRequired,
		isSessionUser: PropTypes.bool.isRequired,
	};

    updateBio = (e) => {
		this.props.addUpdateField('core', 'description', e.target.value)
	};

    render() {

		let { bio, isSessionUser } = this.props,
			placeholder = 'Who are you and what are you working on?',
			bioSet = !!bio;

		console.log( isSessionUser, this.props )

		if( !isSessionUser && !bio ) return null;

		if( !bioSet ) bio = placeholder;

		return (
			<div className="panel p20" id="aboutPanel">

				<h3 className="mtop0 mbot20">About</h3>

				<p className={!!bioSet ? 'text-dark-gray' : 'text-dark-gray'}>
					{ this.props.editing_fields
						? <textarea rows="8" 
									onChange={this.updateBio} 
									className="form-control" 
									defaultValue={this.props.bio} 
									placeholder={placeholder}></textarea>
						: bio
					}
				</p>
	            
            </div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/js/views/Profile/components/Body/components/About.jsx